export const dataLayerPush = (key, payload) => {
    if (typeof window === undefined) {
        console.warn('dataLayerPush: window is undefined');
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: key, ...payload });
};
